/**
 * Types of supported barcodes for generation
 */
export enum BARCODE_TYPES {
  CODE128 = 'code128',
  EAN13 = 'ean13',
  UPCA = 'upca',
  QRCODE = 'qrcode',
}
